__webpack_require__.p = "/nextmind-web-ac/";